import { render } from "./OperationDetails.vue?vue&type=template&id=02473d3c&ts=true"
import script from "./OperationDetails.vue?vue&type=script&lang=ts"
export * from "./OperationDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__